import { InputHTMLAttributes, forwardRef } from "react";
import { clsx } from "clsx";

import { useFieldContext } from "./Field";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

const baseClasses =
  "form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-dobu-orange focus:ring-dobu-orange sm:text-sm";

const errorClasses = "border-red-500 focus:border-red-500 focus:ring-red-500";

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, hasError: hasErrorProp, id: idProp, type = "text", ...props }, ref) => {
    const { hasError: hasErrorContext, id: idContext } = useFieldContext();
    const hasError = hasErrorProp ?? hasErrorContext ?? false;
    const id = idProp ?? idContext;

    return (
      <input
        ref={ref}
        id={id}
        type={type}
        className={clsx(baseClasses, hasError && errorClasses, className)}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export default Input;
